import { CircleAlert } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { Page } from "~/components/layout/Page";
import { Button } from "~/components/ui";
import { rootRoute as R } from "~/routes";

export function AuthorizationFallback() {
  const { t } = useTranslation();

  return (
    <Page className="flex flex-col items-center gap-4">
      <div
        role="alert"
        className="flex w-full max-w-[420px] items-start gap-2.5 rounded-[var(--radius-md)] bg-danger-bg p-4 text-danger"
      >
        <CircleAlert className="mt-px size-4 shrink-0" aria-hidden />
        <div className="flex min-w-0 flex-col gap-1">
          <span className="text-14-bold">{t("ui.error")}</span>
          <span className="text-14-regular">{t("feature.common.unauthorizedOperationRequested")}</span>
        </div>
      </div>

      <Button asChild className="capitalize">
        <Link to={R.$buildPath({})}>{t("ui.moveToTopPage")}</Link>
      </Button>
    </Page>
  );
}
